import type { TranslationGetter } from '../../../types';

export class TranslationService {
  private promoCodeWidgetCopy: ReturnType<TranslationService['createPromoCodeWidgetCopy']>;

  constructor(private t: TranslationGetter) {
    this.promoCodeWidgetCopy = this.createPromoCodeWidgetCopy();
  }

  public api() {
    return {};
  }

  public data() {
    return {
      getPromoCodeWidgetCopy: () => this.promoCodeWidgetCopy,
    };
  }

  public handlers() {
    return {};
  }

  private createPromoCodeWidgetCopy() {
    const { t } = this;

    return {
      singlePromoCodeContainer: {
        heading: t('application-layer.promo-codes.single.heading'),
        percentageOfYourPlan: t('application-layer.promo-codes.single.percentage'),
        percentageOfYourProratedPlan: t('application-layer.promo-codes.single.off-prorated-plan-change'),
        removePromoCodeButtonLabel: t('application-layer.promo-codes.single.remove'),
      },
      addPromoCodeContainer: {
        heading: t('application-layer.promo-codes.add.heading'),
        placeholder: t('application-layer.promo-codes.add.placeholder'),
        applyButtonLabel: t('application-layer.promo-codes.add.apply-button-label'),
      },
    };
  }
}
